import React from 'react';
import { observer } from 'mobx-react';
import { Form } from 'semantic-ui-react';
import { dispatch } from 'rfx-core';

import SSMForm from '#/shared/forms/_.extend';
import FormControls from '#/shared/components/form/controls/FormControls';

import { ResendOTP } from './ui';

const AuthFormOTP = observer(({ form }: { form: SSMForm }) => (
  <Form>
    <form.Field fieldKey="otp" type="text" />
    <FormControls
      controls={{ onSubmit: true }}
      form={form}
      labels={{ submit: 'Submit' }}
    />
    <ResendOTP onClick={() => dispatch('auth.requestNewOTP')}>
      Don&apos;t see it? Click here to get a new code
    </ResendOTP>
    <p className="red">
      {form.error ? 'Verification Code is not correct or has expired.' : ''}
    </p>
  </Form>
));

export default AuthFormOTP;
